
  import React from "react";
  
 export const getLocByIPApi = async () => {

    try{
      let srvResp = await fetch('https://ipapi.co/json',{mode:'cors'}),
          data    = await srvResp.json();

       return(data);

    } catch(e) {
    //   alert("Error. Failed to fetch location data");

    }
  };



// more stabile: return latitude, longtitude
// Use Haversine Formula and reverse geo-coding
  const getGeoLocation = () => {
    navigator.geolocation.getCurrentPosition((oPosition) => {
      console.log(oPosition);
    });
  };